import React from 'react';
import PropTypes from 'prop-types';
import { getItemLink, getItemName } from '../../utils';

const MobileCard = ({ item, source }) => {
    const { urlParams, alias, type } = item;
    return (
        <li className="list-item">
            <a href={getItemLink(type, urlParams, source)}>
                <span className="list-item-text">{getItemName(alias, type, urlParams)}</span>
                <i className="fa fa-chevron-right"/>
            </a>
        </li>
    );
};

MobileCard.propTypes = {
    item: PropTypes.object,
    source: PropTypes.string
};

export default MobileCard;